export default "/images/vendor/@coreui/icons/svg/flag/cif-hr.svg?3ba33716eb9dae29a8379cc3dd4d4d0e";